import { cn } from "@/lib/utils";
import type { GatewayStatus } from "@/types";

interface StatusDotProps {
  status: GatewayStatus;
  label?: string;
  className?: string;
}

export function StatusDot({ status, label, className }: StatusDotProps) {
  const configs: Record<GatewayStatus, { color: string; label: string }> = {
    connected: { color: "bg-emerald-500", label: "Connected" },
    disconnected: { color: "bg-red-500", label: "Disconnected" },
    notApplicable: { color: "bg-muted-foreground", label: "N/A" },
  };

  const config = configs[status];

  return (
    <div className={cn("inline-flex items-center gap-2", className)}>
      <span className={cn("relative flex h-2.5 w-2.5")}>
        <span
          className={cn(
            "absolute inline-flex h-full w-full animate-ping rounded-full opacity-75",
            config.color
          )}
        />
        <span className={cn("relative inline-flex h-2.5 w-2.5 rounded-full", config.color)} />
      </span>
      <span className="text-sm font-medium">{label ?? config.label}</span>
    </div>
  );
}
